import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import useBranding from "@/hooks/useBranding";
import { Button } from "@/components/ui/button";
import { GraduationCap } from "lucide-react";

export default function PublicNav() {
  const { user, logout } = useAuth();
  const b = useBranding();
  const links = [
    { to: "/schools", label: "Schools" },
    { to: "/blogs", label: "Blog" },
    { to: "/events", label: "Events" },
    { to: "/list-your-school", label: "List Your School" },
  ];
  return (
    <header
      data-testid="public-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/75 border-b border-slate-200"
    >
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          {b.site_logo_url ? (
            <img
              src={b.site_logo_url}
              alt={b.site_title || "School Dial"}
              className="h-9 w-auto max-w-[180px] object-contain"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          ) : (
            <>
              <div className="w-9 h-9 rounded-md bg-slate-900 flex items-center justify-center">
                <GraduationCap className="w-5 h-5 text-amber-400" />
              </div>
              <span className="font-black text-lg tracking-tight">{b.site_title || "School Dial"}</span>
            </>
          )}
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-900"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "super_admin" && (
                <Link to="/super">
                  <Button variant="outline" size="sm" data-testid="nav-super-admin">Super Admin</Button>
                </Link>
              )}
              {user.role === "school_admin" && (
                <Link to="/school">
                  <Button variant="outline" size="sm" data-testid="nav-school-admin">School Admin</Button>
                </Link>
              )}
              {user.role === "parent" && (
                <Link to="/parent">
                  <Button variant="outline" size="sm" data-testid="nav-parent-portal">Parent Portal</Button>
                </Link>
              )}
              <Button
                variant="ghost"
                size="sm"
                onClick={logout}
                data-testid="nav-logout-btn"
              >
                Logout
              </Button>
            </>
          ) : (
            <Link to="/login">
              <Button size="sm" data-testid="nav-login-btn" className="bg-slate-900 hover:bg-slate-800">Login</Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
